

import React from 'react'
import Image1 from '../../assets/images/linus_net.jpg'
import Image2 from '../../assets/images/marathon.jpeg'
import Image3 from '../../assets/images/jocke_pris.jpg'
import Stock1 from '../../assets/images/stock/stock-1.jpg'
import Stock2 from '../../assets/images/stock/stock-2.jpg'
import Stock5 from '../../assets/images/stock/stock-5.jpg'
import Layout from '../../components/layout'
import SectionHeading from '../../components/SectionHeading'
import ImageSlider from '../../components/ImageSlider';
import JobCard from '../../components/JobCard'

export default function CareerPage() {
  const images = [
    { id: 1, source: Image1, description: "Vi kan det här med nät!" },
    { id: 2, source: Image2, description: "Vi gör de svåra jobben lätta!" },
    { id: 3, source: Image3, description: "Hög kompetens i alla led!" }
  ]

  const lookingfor = [
    { id: 1, role: "Senior Consultant", locations: ["Sverige"], description: "", image: Stock1 },
    { id: 2, role: "Consultant", locations: ["Sverige"], description: "", image: Stock2 },
    { id: 3, role: "Account Manager", locations: ["Sverige"], description: "", image: Stock5 },

  ]
  return (
    <Layout>
      <div id="career" className="section flex flex-col gap-10 sm:gap-16">
        <div className="grid items-center gap-8 lg:grid-cols-12 lg:gap-10">
          <SectionHeading eyebrow="Karriär" title="Väx med oss" className="min-w-0 lg:col-span-7">
            <p>Vi söker alltid efter hungriga, drivna och passionerade stjärnor - oavsett om du är i början av din resa eller mer erfaren.</p>
            <p>Vill du vara med att skapa och utveckla automatiserade nätverk? Vi söker dig som älskar att lösa problem, utmanas och utvecklas dagligen tillsammans med oss på Acebit?</p>
            <p>Känner du dig träffad? Skicka in en ansökan och berätta varför vi borde jobba tillsammans, så hör vi av oss!</p>
          </SectionHeading>
          <div className="min-w-0 lg:col-span-5">
            <ImageSlider images={images} />
          </div>
        </div>
        <div className="flex flex-col gap-4 sm:gap-6">
          <h3 className="text-xl font-semibold">Lediga tjänster</h3>
          <div className="grid gap-3 md:grid-cols-3 md:gap-6">
            {lookingfor.map((job) => (
              <JobCard data={job} key={job.id} />
            ))}
          </div>
        </div>
      </div>
    </Layout>
  )
}
